import dayjs from 'dayjs';
import * as React from 'react';

import GradeIcon from '@/components/elements/Icon/Grade';
import { MatchResultInfo } from '@/components/layouts/Modal/MatchDetail';
import { EntryRacerScoreDetailOwn } from '@/lib/apollo/types/gen/graphql';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { ScoreCsvIndex, ScoreType } from '@/modelTypes';

import ScoreData from './ScoreData';
import { ContentWrapper, InfoText, RaceResultData } from './style';

const Content: React.FC<{
  own: EntryRacerScoreDetailOwn;
  viewHeldDate: dayjs.Dayjs;
  isFirstDay: boolean;
  index: number;
  openRaceResultModal: (
    matchResult: MatchResultInfo,
    highlightTarget: number,
  ) => void;
}> = ({ own, viewHeldDate, isFirstDay, index, openRaceResultModal }) => {
  const toScoreTypeFromCsv = (csvString: string) => {
    const csvSplit = csvString.split(',');
    const result: ScoreType = {
      heldDate: csvSplit[ScoreCsvIndex.HeldDate],
      velodromeCode: csvSplit[ScoreCsvIndex.VelodromeCode],
      rank: Number(csvSplit[ScoreCsvIndex.Rank]),
      raceNum: Number(csvSplit[ScoreCsvIndex.RaceNum]),
      raceEventName: csvSplit[ScoreCsvIndex.RaceEventName],
      personalStatus: csvSplit[ScoreCsvIndex.PersonalStatus],
      hasBackGet: csvString.includes(',B,'),
    };
    return result;
  };

  const isAddCsv = (csvString: string) => {
    if (csvString) {
      const scoreHeldDate = csvString.split(',')[ScoreCsvIndex.HeldDate];
      return viewHeldDate.format('YYYY-MM-DD') > scoreHeldDate;
    }
    return false;
  };

  const scoreListParser = (arg: EntryRacerScoreDetailOwn): ScoreType[] => {
    let scoreList: ScoreType[] = [];

    if (isAddCsv(arg.scoreCsv1)) {
      const temp = toScoreTypeFromCsv(arg.scoreCsv1);
      scoreList.push(temp);
    }

    if (isAddCsv(arg.scoreCsv2)) {
      const temp = toScoreTypeFromCsv(arg.scoreCsv2);
      scoreList.push(temp);
    }

    if (isAddCsv(arg.scoreCsv3)) {
      const temp = toScoreTypeFromCsv(arg.scoreCsv3);
      scoreList.push(temp);
    }

    if (isAddCsv(arg.scoreCsv4)) {
      const temp = toScoreTypeFromCsv(arg.scoreCsv4);
      scoreList.push(temp);
    }

    if (isAddCsv(arg.scoreCsv5)) {
      const temp = toScoreTypeFromCsv(arg.scoreCsv5);
      scoreList.push(temp);
    }

    if (isAddCsv(arg.scoreCsv6)) {
      const temp = toScoreTypeFromCsv(arg.scoreCsv6);
      scoreList.push(temp);
    }

    if (isAddCsv(arg.scoreCsv7)) {
      const temp = toScoreTypeFromCsv(arg.scoreCsv7);
      scoreList.push(temp);
    }

    if (scoreList.length === 0) {
      const temp: ScoreType = {
        heldDate: '',
        velodromeCode: '',
        rank: 0,
        raceNum: 0,
        raceEventName: '',
        personalStatus: '欠場',
        hasBackGet: false,
      };

      if (index === 0 && !isFirstDay) {
        temp.personalStatus = ''; // 開催初日ではなく「index = 0」の場合、今開催初出場なので「欠場」を表示しない
      }

      scoreList.push(temp);
    }

    return scoreList;
  };

  return (
    <ContentWrapper>
      <InfoText data-testid="result-info">
        <span>
          {`${own.heldFirstDate.format('M/D')} ${
            getVelodromeByCode(own.velodromeCode).name
          }`}
        </span>
        <GradeIcon gradeName={own.gradeName} width="18px" height="12px" />
      </InfoText>

      <RaceResultData>
        {scoreListParser(own).map((s, si) => (
          <ScoreData
            key={`scoreinfo-${si}`}
            scoreData={s}
            gradeName={own.gradeName}
            registrationNum={own.registrationNum}
            openRaceResultModal={openRaceResultModal}
          />
        ))}
      </RaceResultData>
    </ContentWrapper>
  );
};

export default Content;
